import { SectionViewedLogger, SectionViewedLoggerProps } from '@/vdp/Analytics';
import { SectionName } from '~/constants/vdp/section';
import { SectionAnalyticsProvider } from '~/context/vdp/SectionAnalyticsContext';

type OwnProps = React.PropsWithChildren<SectionViewedLoggerProps>;

export default function SectionContainer({
  children,
  section,
  ...props
}: OwnProps) {
  const analyticsId = section ? SectionName[section] : null;

  return (
    <SectionAnalyticsProvider analyticsId={analyticsId}>
      <SectionViewedLogger section={section} {...props}>
        {children}
      </SectionViewedLogger>
    </SectionAnalyticsProvider>
  );
}
